import React from 'react';

const Link = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M5.9987 11.3332H4.66536C3.78131 11.3332 2.93346 10.982 2.30834 10.3569C1.68322 9.73174 1.33203 8.88389 1.33203 7.99984C1.33203 7.11578 1.68322 6.26794 2.30834 5.64281C2.93346 5.01769 3.78131 4.6665 4.66536 4.6665H5.9987"
        stroke="#666666"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 4.6665H11.3333C12.2174 4.6665 13.0652 5.01769 13.6904 5.64281C14.3155 6.26794 14.6667 7.11578 14.6667 7.99984C14.6667 8.88389 14.3155 9.73174 13.6904 10.3569C13.0652 10.982 12.2174 11.3332 11.3333 11.3332H10"
        stroke="#666666"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33203 8H10.6654"
        stroke="#666666"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Link;
